// extracted by mini-css-extract-plugin
export default {"questionContainer":"QuestionCard_questionContainer__p8kCj"};